import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import AdminVehicleForm from './pages/AdminVehicleForm';
import AdminVehicleList from './pages/AdminVehiclesList';
import AdminBlogPage from './pages/AdminBLogPAge';
import AdminJobPostsPage from './pages/AdminJobPostsPage';
import AdminJobApplicationsPage from './pages/AdminJobApplicationPage';
import AdminQRCodeUpload from './pages/AdminQRCodeUpload';

function AdminApp() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="register" element={<Register />} />
      <Route path="login" element={<Login />} />

      {/* Protected admin routes */}
      <Route
        path="profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      {/* Vehicles management */}
      <Route
        path="vehicles"
        element={
          <ProtectedRoute>
            <AdminVehicleList />
          </ProtectedRoute>
        }
      />
      <Route
        path="vehicles/new"
        element={
          <ProtectedRoute>
            <AdminVehicleForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="vehicles/edit/:id"
        element={
          <ProtectedRoute>
            <AdminVehicleForm />
          </ProtectedRoute>
        }
      />

      {/* Blogs */}
      <Route
        path="blogs"
        element={
          <ProtectedRoute>
            <AdminBlogPage />
          </ProtectedRoute>
        }
      />

      {/* QR Code Upload */}
      <Route
        path="qrcode"
        element={
          <ProtectedRoute>
            <AdminQRCodeUpload />
          </ProtectedRoute>
        }
      />

      {/* Job Posts */}
      <Route
        path="jobposts"
        element={
          <ProtectedRoute>
            <AdminJobPostsPage />
          </ProtectedRoute>
        }
      />

      {/* Job Applications */}
      <Route
        path="applications"
        element={
          <ProtectedRoute>
            <AdminJobApplicationsPage />
          </ProtectedRoute>
        }
      />

      {/* Redirect unknown /admin paths */}
      <Route path="*" element={<Navigate to="vehicles" replace />} />
    </Routes>
  );
}

export default AdminApp;
